import axios from "axios"
import { useEffect, useState } from "react"
import Common from "../components/common"
import React from "react";
import { useDispatch, useSelector } from "react-redux"
import { setapidata } from "../slices/customerSlice"
import Debittotal from "../components/debittotal";
import Button from 'react-bootstrap/Button';
import { useNavigate } from 'react-router'
import moment from "moment";
import Spinner from 'react-bootstrap/Spinner';
import EmailForm from "../email"
import { setOwnerId } from "../slices/shopOwnerLoginSlice";
import { setdueamount } from "../slices/customerSlice";
import { setinterestdetails } from "../slices/customerSlice";

function DEBITLST() {
    let navigate = useNavigate()
    let dispatch = useDispatch()
    let { ownerid } = useSelector((state) => state.ShopOwnerLogin)
    let { apidata } = useSelector((state) => state.customer)
    const [debit, setdebit] = useState([]);
    let [isdisable, setisdisable] = useState(false)
    // let owner_id = ownerid.data.id
    let token = localStorage.getItem("ownertoken")
    let duedate = []

    console.log("", debit)
    //    for(let i=0;i<apidata.length;i++){
    //     // console.log('loop',apidata[i].debits)
    //     for (let j=0;j<apidata[i].debits.length;j++){
    //         if(apidata[i].debits[j].due_date != ""){
    //             // if(apidata[i].debits[j]==apidata[i].debits[i])
    //         //  let hello =  moment(apidata[i].debits[j].due_date).subtract(7,"day").format('LL') 
    //            duedate.push(apidata[i].debits[j])
    //         }          
    //     }
    //    }
    //    console.log(duedate)
    //    for (let i=0;i<duedate.length;i++){
    //       let sepdue =  moment (duedate[i].due_date).subtract(7,"day").format('LL')
    //       console.log(sepdue,duedate[i].due_date)
    //    }


    console.log(duedate)

    useEffect(() => {
        
            let token = localStorage.getItem("ownertoken")
    if(ownerid?.data?.id && token){
      axios({
        method: 'get',
        url: `https://agaram.academy/api/retail/index.php?request=getAllCustomers&owner_id=${ownerid.data.id}&token=${token}`,
  
      }).then(function (response) {
        console.log(response)
        dispatch(setapidata(response.data.data))
        console.log(apidata)
        console.log(response.data.email)

      }).catch(err=>{
        console.log(err)
      })

  }else if( token){
    axios.post(`https://agaram.academy/api/retail/index.php?request=getShopOwnerDetailsByToken&token=${token}`)
    .then(function (response) {
      console.log("checking datas:", response.data)
      dispatch(setOwnerId(response.data))

    })
  }
}, [ownerid.data])
            // const response = await axios.get(`https://agaram.academy/api/retail/index.php?request=getAllCustomers&owner_id=${localStorage.getItem('userid')}&token=${token}`)
            // let customer_detail = response.data.data
            // dispatch(setapidata(customer_detail))

       

       
   



    useEffect(() => {
        const customerList = Debittotal(apidata)
        setdebit(customerList)
    }, [apidata]);



    const credit = (id, amount) => {
        dispatch(setdueamount(amount))
        navigate(`/credit/${id}`)
    }


    const deletecustomer = () => {

        debit.map((iteam) => {
            if (iteam.amount == 0 && iteam.debits[0]) {
                alert(iteam.id)
                let formData = new FormData();
                formData.append("owner_id", ownerid)
                formData.append("customer_id", iteam.id)
                axios.post(`https://agaram.academy/api/retail/index.php?request=delete_debit&token=${token}`, formData).then(function (response) {
                })
            }
        })
    }

    useEffect(() => {
        deletecustomer()
    }, [apidata]);

    function setinterest() {
        apidata.map((item) => {
            let interestcount = 0
            item.debits.map((debit_details) => {
                if (debit_details.type == "interest") {
                    interestcount += 1
                }
                if (interestcount == 0) {
                    let total_debit_amount = 0
                    debit.map((debit_amount) => {
                        total_debit_amount = debit_amount.amount
                    })
                    console.log("oo", item.debits[0].due_date)
                    if (item.debits[0].due_date > moment().format('YYYY-MM-DD') && total_debit_amount != 0) {
                        setisdisable(true)
                        let fineamount = (total_debit_amount * 0.02)
                        let formData = new FormData();
                        formData.append("customer_id", item.id)
                        formData.append("last_purchase_at", moment().format('YYYY-MM-DD'))
                        formData.append("amount", fineamount)
                        formData.append("due_date", "")
                        formData.append("type", "interest")
                        axios.post(`https://agaram.academy/api/retail/index.php?request=create_debit&token=${token}`, formData).then(function (res) {
                        }
                        )
                    }
                }
            }
            )
        })
    }

    useEffect(() => {
        if (isdisable == false) {
            setinterest()
        }
    }, [apidata.debits]
    )




    return (
        <>
            <Common />

            <div className="table-responsive">
                < table className=" table table-light table-striped table-hover m-3 table-bordered ">
                    <thead>
                        <tr>
                            <th>Customer ID</th>
                            <th>Customer Name</th>
                            <th>Debt Amount</th>
                            <th>Date of  Last Debt</th>
                            <th>Due date</th>
                            <th>Credit</th>
                            <th>Interest Details</th>
                        </tr>
                    </thead>
                    <tbody>
                        {debit.map((customer) => {
                            if (!customer) {
                                return <Spinner animation="grow" />;
                              } else {

                            if (customer.amount) {
                                duedate.push(customer.debits[0].due_date)
                                return (
                                    <tr>
                                        <td>{customer.id}</td>
                                        <td>{customer.name}</td>
                                        <td>{customer.amount}</td>
                                        <td>{customer.debits[0].last_purchase_at}</td>
                                        <td>{customer.debits[0].due_date}</td>
                                        <td><Button variant="outline-primary" onClick={() => credit(customer.id, customer.amount)}>Credit</Button></td>
                                        <td><Button variant="outline-primary" onClick={() => navigate(`/interest/${customer.id}`)}>Interest</Button></td>
                                    </tr>)
                            }
 } })}
                    </tbody>
                </table >
            </div>
        </>
    )
}


export default DEBITLST